import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { FullScreenLoading, NUGGET_VARIANTS } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { useGetCollegeByIdQuery } from '@backrs_ui/grow-ui/src/redux/college/college.api';
import { useAppSelector, useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { resetMakeItPersonal } from '@backrs_ui/grow-ui/src/redux/makeItPersonal/makeItPersonal';
import {
  deleteContentNuggetBookmark,
  postContentNuggetBookmark,
} from '@backrs_ui/grow-ui/src/redux/user/thunks/nuggetBookmark';
import { selectBookmarkedNuggetId } from '@backrs_ui/grow-ui/src/redux/user/user';

import { CollegePage } from './CollegePage';
import { SEARCH_PAGE_CATEGORIES } from '../Search/search.types';

export const CollegePageContainer = () => {
  const { universityId } = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    data: foundCollege,
    isLoading,
    error,
  } = useGetCollegeByIdQuery(universityId || '', {
    skip: !universityId,
  });

  const collegeBookmarkId = useAppSelector(
    selectBookmarkedNuggetId({
      nuggetId: foundCollege?.id,
      variant: NUGGET_VARIANTS.INSTITUTION,
    }),
  );

  useEffect(() => {
    if (!universityId) {
      navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.COLLEGES}`);

      return;
    }

    return () => {
      dispatch(resetMakeItPersonal());
    };
  }, [navigate, universityId, dispatch]);

  if (!universityId || isLoading || !foundCollege || error) {
    return <FullScreenLoading />;
  }

  const handleBookmark = () => {
    if (collegeBookmarkId) {
      dispatch(deleteContentNuggetBookmark(collegeBookmarkId));

      return;
    }

    dispatch(postContentNuggetBookmark({ type: 'college', itemId: foundCollege.id }));
  };

  return (
    <CollegePage
      college={foundCollege}
      handleBookmark={handleBookmark}
      hasBookmarked={!!collegeBookmarkId}
    />
  );
};
